module.exports = __webpack_public_path__ + "img/main_btn.93f0084e.png";